import { connect } from 'react-redux';

// selectors
import { hitActualizePriceChange } from 'checkout/store/actions/analytics';
import {
  getIsPriceChangedOnPay,
  getPriceOnPay,
  getPackageFullPrice,
} from '../../../store/selectors/order';

import { getIsMobile } from '../../../../../store/view/selectors';
import { getHotelLinkWithRequestId } from '../../../store/selectors/hotel';

// actions
import { confirmOrderAction } from '../../../store/actions/order';

import PriceChangePopup from '../../../../../components/PriceChangePopup';

const mapStateToProps = (state) => ({
  isShown: getIsPriceChangedOnPay(state),
  initialPrice: getPriceOnPay(state) || 0,
  actualizePrice: getPackageFullPrice(state) || 0,
  isMobile: getIsMobile(state),
  hotelLink: getHotelLinkWithRequestId(state),
});

const mapDispatchToProps = {
  onOrderConfirmed: confirmOrderAction,
  onHitActualizePriceChange: hitActualizePriceChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceChangePopup);
